export async function checkBrandReady(brandId: number, request: typeof fetch = fetch): Promise<string | null> {
  try {
    const response = await request(`/api/brands/${brandId}/readiness`, { credentials: 'include' });
    if (!response.ok) return 'We could not check your brand analysis. Please try again.';
    const state = await response.json();
    if (state.ready === true) return null;
    return state.code === 'BRAND_ANALYSIS_FAILED'
      ? 'Your brand analysis could not finish. Retry the analysis from your brand page before running this task.'
      : 'Your brand is still being analysed. Please wait for it to finish, then press Send again.';
  } catch {
    return 'We could not check your brand analysis. Please try again.';
  }
}
